<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-card-title>
        <span class="text-h6">Modifier l'ingrédient</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="formRef" lazy-validation>
          <div v-if="local.productImage" class="mb-4 d-flex justify-center">
            <v-img :src="local.productImage" max-width="180" max-height="120" contain class="rounded"/>
          </div>
          <v-text-field v-model="local.productName" label="Nom" required />
          <v-text-field v-model="local.productBrand" label="Marque" />
          <v-text-field v-model="local.category" label="Catégorie" />
          <v-text-field v-model.number="local.servingQuantity" label="Portion (g)" type="number" />
          <v-text-field v-model="local.productImage" label="URL image" placeholder="https://..." />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="onCancel">Annuler</v-btn>
        <v-btn
          color="accent"
          @click="onSave"
          :disabled="!local.productName || !local.productBrand || !local.servingQuantity"
        >Enregistrer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  ingredient: { type: Object, default: null }
})
const emit = defineEmits(['update:modelValue','saved'])

const show = ref(props.modelValue)
const local = ref({})
const formRef = ref(null)

watch(() => props.modelValue, (v) => (show.value = v))
watch(show, (v) => emit('update:modelValue', v))

watch(
  () => props.ingredient,
  (v) => {
    local.value = v ? { ...v } : { productName: '', productBrand: '', category: '', servingQuantity: null, productImage: '' }
  },
  { immediate: true }
)

function onCancel() {
  show.value = false
}

function onSave() {
  // basic validation
  if (!local.value.productName || !local.value.productName.trim()) return
  emit('saved', { ...local.value })
  show.value = false
}
</script>

<style scoped>
/* small tweaks */
</style>
